import { getLocalTimeZone } from '@internationalized/date';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TmdxAvatar } from '@ds';
import { Form } from '@ui';
import { ShiftUnavailabilitiesFormType } from '@lp/features/Scheduler/SchedulerSurgeons/components/NAShiftModal/types';
import { toLocalDateFromApiDateKey } from '@lp/features/Scheduler/utils';
import { SResource, SShift } from '@/api/apis/resources/schedule';
import { formatDate, getFullName } from '@/utils/helpers';
import { getDefaultValues, sShiftUnavailabilitiesFormSchema } from './config';
import { NAShiftModalForm } from './forms';

type NAShiftModalProps = {
  day: string;
  resource: SResource;
  shiftData?: SShift;
  onClose: () => void;
  onConfirm: (formData: ShiftUnavailabilitiesFormType) => void;
};

export const NAShiftModal = ({ day, resource, shiftData, onClose, onConfirm }: NAShiftModalProps) => {
  const fullName = getFullName(resource.firstName, resource.lastName);
  const timezone = resource.timezone ?? getLocalTimeZone();

  return (
    <Modal isOpen onClose={onClose}>
      <ModalContent>
        <Form<ShiftUnavailabilitiesFormType>
          defaultValues={getDefaultValues(shiftData)}
          schema={sShiftUnavailabilitiesFormSchema}
          onSubmit={onConfirm}
        >
          <ModalHeader>
            <h1 className="text-hm text-base-20">Unavailable</h1>
          </ModalHeader>
          <ModalBody>
            <div className="flex gap-2 items-center">
              <TmdxAvatar size="lg" name={fullName} src={resource.profilePhoto} />
              <div>{fullName}</div>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-l-sb text-base-5">Date</span>
              <span className="text-m-r text-base-5">{formatDate(toLocalDateFromApiDateKey(day), 'MM/dd/yyyy')}</span>
            </div>
            <div>
              <NAShiftModalForm date={day} timezone={timezone} />
            </div>
          </ModalBody>
          <ModalFooter className="flex justify-between">
            <Button size="sm" variant="light" onClick={onClose}>
              Discard
            </Button>
            <Button size="sm" type="submit">
              Save
            </Button>
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  );
};
